import { memo } from 'react';

import useStyles from './styles';
import ISideBarHeadingProps from './types';

function SidebarHeading({ children }: ISideBarHeadingProps) {
  const styles = useStyles();
  return <div className={styles.root}>{children}</div>;
}

export default memo(SidebarHeading);
